import type { ManualTarget } from '@/shared/config/manual';

import { HelpLink } from '../help-link';

interface PageHeaderProps {
  title: string;
  description?: string;
  helpTarget?: ManualTarget | null;
}

export function PageHeader({ title, description, helpTarget }: PageHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <div className="flex items-center gap-1">
          <h1 className="text-2xl font-semibold">{title}</h1>
          <HelpLink target={helpTarget} className="h-7 w-7" />
        </div>
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
      </div>
    </div>
  );
}
